// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1DzvG","alert":"SettungsInbox_alert__2Bces"};